var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentsIconWh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.35155,
    y: 0.448238,
    width: 15.1753,
    height: 22.3143,
    rx: 1.625,
    transform: "rotate(12.694 5.35155 0.448238)",
    stroke: "white",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.7146,
    y: 1.84286,
    width: 15.1753,
    height: 22.3143,
    rx: 1.625,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3166 15.1966H5.97499C5.77071 15.1966 5.63452 15.3328 5.63452 15.5371C5.63452 15.7414 5.77071 15.8775 5.97499 15.8775H14.2825C14.4868 15.8775 14.623 15.7414 14.623 15.5371C14.623 15.3328 14.4868 15.1966 14.3166 15.1966Z",
    fill: "#543379"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3166 17.0692H5.97499C5.77071 17.0692 5.63452 17.2054 5.63452 17.4097C5.63452 17.614 5.77071 17.7502 5.97499 17.7502H14.2825C14.4868 17.7502 14.623 17.614 14.623 17.4097C14.623 17.2054 14.4868 17.0692 14.3166 17.0692Z",
    fill: "#543379"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3166 18.9418H5.97499C5.77071 18.9418 5.63452 19.078 5.63452 19.2822C5.63452 19.4865 5.77071 19.6227 5.97499 19.6227H14.2825C14.4868 19.6227 14.623 19.4865 14.623 19.2822C14.623 19.078 14.4868 18.9418 14.3166 18.9418Z",
    fill: "#543379"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87795 20.6881H5.80093C5.70108 20.6881 5.63452 20.7979 5.63452 20.9627C5.63452 21.1274 5.70108 21.2372 5.80093 21.2372H9.86131C9.96115 21.2372 10.0277 21.1274 10.0277 20.9627C10.0277 20.7979 9.96115 20.6881 9.87795 20.6881Z",
    fill: "#543379"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0456 7.06977H12.3475V5.37174C12.3475 5.13753 12.1523 4.94235 11.9181 4.94235H9.14664C8.91243 4.94235 8.71725 5.13753 8.71725 5.37174V7.06977H7.01923C6.78502 7.06977 6.58984 7.26495 6.58984 7.49916V10.2706C6.58984 10.5049 6.78502 10.7 7.01923 10.7H8.71725V12.3981C8.71725 12.6323 8.91243 12.8274 9.14664 12.8274H11.9181C12.1523 12.8274 12.3475 12.6323 12.3475 12.3981V10.7H14.0456C14.2798 10.7 14.4749 10.5049 14.4749 10.2706V7.49916C14.4749 7.24543 14.2798 7.06977 14.0456 7.06977ZM13.6357 9.84126H11.9376C11.7034 9.84126 11.5083 10.0364 11.5083 10.2706V11.9687H9.57603V10.2706C9.57603 10.0364 9.38085 9.84126 9.14664 9.84126H7.44861V7.90902H9.14664C9.38085 7.90902 9.57603 7.71384 9.57603 7.47963V5.7816H11.5083V7.47963C11.5083 7.71384 11.7034 7.90902 11.9376 7.90902H13.6357V9.84126Z",
    fill: "#543379"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsIconWh);
export default __webpack_public_path__ + "static/media/documents_icon_wh.08b04aa4cc0f0fdfb9a913d8aabdf074.svg";
export { ForwardRef as ReactComponent };